import axios from 'axios'

class FormsRest {
  public async signup (campaignId: number, data: Record<string, any>): Promise<void> {
    return await axios.post(`/api/campaigns/${campaignId}/competition/signup`, data)
  }
}

export default new FormsRest()
